
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("32xcy", function(module, exports) {
/* ContentTreeSearch.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $4rwCt = parcelRequire("4rwCt");


var $4noo5 = parcelRequire("4noo5");


var $jluld = parcelRequire("jluld");


var $inPa6 = parcelRequire("inPa6");


var $7yDmn = parcelRequire("7yDmn");


var $6F6hl = parcelRequire("6F6hl");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $ep3mz = parcelRequire("ep3mz");


var $56QzY = parcelRequire("56QzY");


var $6p02T = parcelRequire("6p02T");


var $b3j2Y = parcelRequire("b3j2Y");


var $ddhUv = parcelRequire("ddhUv");


var $gz8ZY = parcelRequire("gz8ZY");


var $6MlZq = parcelRequire("6MlZq");


var $bQm3c = parcelRequire("bQm3c");


var $2vuKf = parcelRequire("2vuKf");


var $bwL2u = parcelRequire("bwL2u");


var $6mKj3 = parcelRequire("6mKj3");


var $5oz05 = parcelRequire("5oz05");


var $882Qs = parcelRequire("882Qs");


var $amtnj = parcelRequire("amtnj");

const $c78306c195e02053$var$i18n = (0, $cgtv4.defineMessages)({
    searchLabel: {
        id: "space-views.content-tree-search.placeholder",
        defaultMessage: "Search by title"
    },
    clearSearch: {
        id: "space-views.content-tree-search.clear-search",
        defaultMessage: "Clear search"
    },
    searchInputDescription: {
        id: "space-views.content-tree-search.input-description",
        defaultMessage: "Results will update as you type."
    },
    searchResultsCount: {
        id: "space-views.content-tree-search.results-count",
        defaultMessage: "{count} {count, plural, one {result} other {results}} found"
    },
    disabledSearchTooltip: {
        id: "space-views.content-tree-search.disabled-label",
        defaultMessage: "Search is disabled when editing multiple items"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c78306c195e02053$var$TextfieldWrapperDiv = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNav4Enabled: isNav4Enabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pku2gc _otyru2gc _1f4s12b0 _1thze4h9",
            __cmplp.isNav4Enabled ? "_18u0r5cr" : "_18u0u2gc",
            __cmplp.isNav4Enabled ? "_n6341l7x" : "_n6341wug",
            __cmplp.className
        ])
    });
});
const $c78306c195e02053$var$legacySearchIconStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c78306c195e02053$var$ClearSearchButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _bfhk1j28 _2hwxt94y _4t3i1ou6 _1bsb1ou6 _u5f3rdoj _1e0c1txw _4cvr1h6o _1bah1h6o _80omtlke",
            __cmplp.className
        ])
    });
}); // same styles as a tooltip but with narrower width
const $c78306c195e02053$var$tooltipStyles = null;
const $c78306c195e02053$var$ToolTipOverride = /*#__PURE__*/ (0, $42omo.forwardRef)(function ToolTipOverride({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $afneb.default), {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_11q71aqn _2rkofajl _11c8wadc _ca0qyh40 _u5f3i2wt _n3tdyh40 _19bvi2wt _syaz15cr _p12f13lo"
        ])
    }, children);
});
const $c78306c195e02053$var$overlayCSS = null;
const $c78306c195e02053$var$overlayLoading = null;
const $c78306c195e02053$var$DisabledOverlay = ({ loading: loading, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "content-tree-search-overlay",
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1osq",
            loading && "_tzy4105o _lcxvglyw _80om13gf"
        ])
    }, children);

const $c78306c195e02053$var$SpaceViewsMenuLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ceKkd",
    name: "SpaceViewsMenuLoader",
    loader: async ()=>(await (parcelRequire("4Uzty"))).SpaceViewsMenu
});
const $c78306c195e02053$export$1b6339bfe8fdc588 = ({ children: children, contentTreeSize: contentTreeSize, shouldRenderAfterIcon: shouldRenderAfterIcon, selection: selection, setSelection: setSelection, isLicensed: isLicensed, isSpaceAdminOrSuperAdmin: isSpaceAdminOrSuperAdmin, ...hoverPageCardProps })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const intl = (0, $8C5kA.default)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const inputRef = (0, $42omo.useRef)(null);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const [searchText, setSearchText] = (0, $42omo.useState)('');
    const debouncedSearchText = (0, $ddhUv.useDebounce)(searchText, 200);
    const { searchResult: searchResult, loading: loading, error: error } = (0, $5oz05.useContentTreeSearch)(debouncedSearchText, 'sideNavigation');
    const isCreationADropdown = (0, $6MlZq.useIsCreationDropdownEnabled)();
    const { disableMultiSelect: disableMultiSelect, exitMultiSelect: exitMultiSelect } = (0, $bwL2u.useContentTreeSelectionActions)();
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    const handleChange = (0, $42omo.useCallback)((e)=>{
        const inputValue = e.currentTarget.value || '';
        if (inputValue.length > 0) disableMultiSelect();
        else exitMultiSelect();
        setSearchText(inputValue);
    }, [
        disableMultiSelect,
        exitMultiSelect
    ]);
    const handleOnClearSearch = (0, $42omo.useCallback)(()=>{
        setSearchText('');
        exitMultiSelect();
    }, [
        exitMultiSelect
    ]);
    const onItemClick = (0, $42omo.useCallback)((id, index)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'pageTree',
                source: 'pageTree',
                objectId: id,
                attributes: {
                    spaceView: 'contentTreeSearch',
                    navdexPointType: (0, $56QzY.TOUCH),
                    searchResultCount: searchResult?.length,
                    searchResultIndex: index,
                    contentTreeSize: contentTreeSize
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        searchResult,
        contentTreeSize
    ]);
    const handleTextfieldFocus = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'focused',
                actionSubject: 'contentTreeSearch',
                source: 'sideNavigation',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    contentTreeSize: contentTreeSize
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentTreeSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "content-tree-search",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c78306c195e02053$var$TextfieldWrapperDiv, {
        isNav4Enabled: isNav4Enabled,
        id: "contentTreeSearch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: isMultiSelectActive ? intl.formatMessage($c78306c195e02053$var$i18n.disabledSearchTooltip) : '',
        position: "bottom",
        component: $c78306c195e02053$var$ToolTipOverride
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            ...tooltipProps,
            ref: (0, $4rwCt.mergeRefs)([
                tooltipProps.ref,
                inputRef
            ]),
            "aria-label": intl.formatMessage($c78306c195e02053$var$i18n.searchLabel),
            "aria-describedby": "contentTreeSearchInfo",
            placeholder: intl.formatMessage($c78306c195e02053$var$i18n.searchLabel),
            onChange: handleChange,
            onFocus: handleTextfieldFocus,
            value: searchText,
            elemBeforeInput: isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                paddingInlineStart: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                label: "",
                color: "var(--ds-icon-accent-gray, #7D818A)"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    "_w8l5gktf _1752gktf _t7blv77o _gncu1b66 _i2i31l7b"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-accent-gray, #7D818A)"
            })),
            elemAfterInput: searchText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c78306c195e02053$var$ClearSearchButton, {
                onClick: handleOnClearSearch
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                label: intl.formatMessage($c78306c195e02053$var$i18n.clearSearch),
                color: "var(--ds-icon-subtle, #505258)"
            })) : null,
            isCompact: true,
            isDisabled: isMultiSelectActive
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        id: "contentTreeSearchInfo"
    }, intl.formatMessage($c78306c195e02053$var$i18n.searchInputDescription)), isNav4Enabled && edition === 'PREMIUM' && isLicensed && isSpaceAdminOrSuperAdmin && (0, $6mKj3.expVal)('confluence_bulk_actions_in_content_tree', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c78306c195e02053$var$SpaceViewsMenuLoader, {
        selection: selection,
        setSelection: setSelection,
        isWhiteboardBetaEnabled: isCreationADropdown,
        edition: edition,
        isSpaceAdminOrSuperAdmin: isSpaceAdminOrSuperAdmin
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c78306c195e02053$var$DisabledOverlay, {
        loading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $882Qs.ContentTreeSearchErrorLoader), null)) : searchResult && searchResult.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $882Qs.ContentTreeSearchEmptyLoader), null) : null), !error ? !searchResult ? children : searchResult.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$c78306c195e02053$var$i18n.searchResultsCount,
        values: {
            count: searchResult.length
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $amtnj.SpaceViewsList), {
        pagesList: searchResult,
        spaceKey: spaceKey,
        contentId: contentId,
        onItemClick: onItemClick,
        renderTitle: ({ title: title })=>(0, $6p02T.enrichExcerpt)(title),
        shouldRenderAfterIcon: shouldRenderAfterIcon,
        ...hoverPageCardProps
    })) : null : null));
};
module.exports["ContentTreeSearch"] = $c78306c195e02053$export$1b6339bfe8fdc588;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("ddhUv", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $10706a64f92ac80e$export$21805fee57372823 = (key, time)=>{
    const [lastKey, setLastKey] = (0, $42omo.useState)(key);
    (0, $42omo.useEffect)(()=>{
        if (key !== lastKey) {
            const timeout = setTimeout(()=>{
                setLastKey(key);
            }, time);
            return ()=>clearTimeout(timeout);
        }
    }, [
        key,
        lastKey,
        time
    ]);
    return lastKey;
};
module.exports["useDebounce"] = $10706a64f92ac80e$export$21805fee57372823;

});

parcelRegister("6MlZq", function(module, exports) {
const $2b534f0161088f49$export$f5501c77c624c70 = ()=>{
    /**
	 * DO NOT MODIFY THIS METHOD.
	 * This method has been refactored to return true as part of an effort to remove LaunchDarkly feature flags.
	 * Returning true avoids regressions.
	 * This method will be removed when ALL dependent feature flags have been removed.
	 * This work is being tracked in https://hello.jira.atlassian.cloud/browse/CTIA-2808
	 */ return true;
};
module.exports["useIsCreationDropdownEnabled"] = $2b534f0161088f49$export$f5501c77c624c70;

});

parcelRegister("5oz05", function(module, exports) {
/**
 * @Relay no-runtime
 * @graphql agg
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");


var $gKr8t = parcelRequire("gKr8t");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $56QzY = parcelRequire("56QzY");


var $YlCKe = parcelRequire("YlCKe");

const $a306f397805d802c$var$SEARCH_PAGE_SIZE = 50;
const $a306f397805d802c$var$transformSearchData = (data)=>{
    const nodes = data?.search?.search?.edges?.map((edge)=>edge.node) || undefined;
    return nodes?.map(({ entityId: entityId, title: title, type: type, confluenceEntity: confluenceEntity })=>({
            id: entityId,
            title: title,
            displayEmoji: confluenceEntity?.metadata?.titleEmojiPublished?.value,
            type: type,
            subType: confluenceEntity?.subtype?.toLowerCase() ?? '',
            // TODO: Show super admins which pages are restricted -- this info is not yet available in AGG
            hasRestrictions: false,
            hasInheritedRestrictions: false
        }));
};
const $a306f397805d802c$export$701bedbfad07b1e = (searchText, source, spaceKey)=>{
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const resolvedSpaceKey = spaceKey ?? pageSpaceKey; // Use provided spaceKey or fall back to context
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(resolvedSpaceKey);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)(/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ (0, $eSUdr.default)`query useContentTreeSearchContentTreeSearchQuery($experience:String!$searchText:String!$first:Int$filters:SearchFilterInput!){search{search(experience:$experience query:$searchText first:$first filters:$filters){edges{node{id title type ...on SearchConfluencePageBlogAttachment{entityId confluenceEntity{...on ConfluencePage{id subtype metadata{titleEmojiPublished{id value}}}}}}}}}}`, {
        variables: {
            searchText: searchText,
            experience: 'confluence.searchInTree',
            first: $a306f397805d802c$var$SEARCH_PAGE_SIZE,
            filters: {
                entities: [
                    'ati:cloud:confluence:page',
                    'ati:cloud:confluence:whiteboard',
                    'ati:cloud:confluence:database',
                    'ati:cloud:confluence:embed'
                ],
                locations: [
                    'ari:cloud:confluence::site/'.concat(cloudId)
                ],
                confluenceFilters: {
                    spacesFilter: resolvedSpaceKey ? [
                        resolvedSpaceKey
                    ] : undefined,
                    contentStatuses: [
                        (0, $YlCKe.SearchConfluenceDocumentStatus).CURRENT
                    ],
                    titleMatchOnly: true
                }
            }
        },
        client: (0, $gKr8t.getAGGClient)(),
        skip: searchText.length === 0
    });
    const searchResult = (0, $42omo.useMemo)(()=>$a306f397805d802c$var$transformSearchData(data), [
        data
    ]);
    (0, $42omo.useEffect)(()=>{
        if (searchResult) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'searched',
                actionSubject: 'contentTree',
                source: source,
                containerId: spaceId,
                containerType: 'space',
                attributes: {
                    searchResultCount: searchResult.length,
                    navdexPointType: (0, $56QzY.TOUCH)
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        searchResult,
        spaceId,
        source
    ]);
    return {
        searchResult: searchResult,
        loading: loading,
        error: error
    };
};
module.exports["useContentTreeSearch"] = $a306f397805d802c$export$701bedbfad07b1e;

});

parcelRegister("YlCKe", function(module, exports) {
/**
 * @generated SignedSource<<b2b2525754043e24c823ceeabd285e4d>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: agg
 *
 * @see https://go/typsy
 **/ var $748ce020ea1d386c$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $748ce020ea1d386c$export$77cdd20d47be2a2f = /*#__PURE__*/ function(SearchCombinationType) {
    SearchCombinationType["AND"] = "AND";
    SearchCombinationType["OR"] = "OR";
    return SearchCombinationType;
}({});
var $748ce020ea1d386c$export$75fb70288e44d634 = /*#__PURE__*/ function(SearchConfluenceDocumentStatus) {
    SearchConfluenceDocumentStatus["CURRENT"] = "CURRENT";
    SearchConfluenceDocumentStatus["ARCHIVED"] = "ARCHIVED";
    SearchConfluenceDocumentStatus["DRAFT"] = "DRAFT";
    return SearchConfluenceDocumentStatus;
}({});
var $748ce020ea1d386c$export$641731d7c91b88de = /*#__PURE__*/ function(SearchConfluenceRangeField) {
    SearchConfluenceRangeField["LASTMODIFIED"] = "LASTMODIFIED";
    SearchConfluenceRangeField["CREATED"] = "CREATED";
    return SearchConfluenceRangeField;
}({});
var $748ce020ea1d386c$export$3646d7b76c420c42 = /*#__PURE__*/ function(SearchContainerStatus) {
    SearchContainerStatus["ARCHIVED"] = "ARCHIVED";
    SearchContainerStatus["CURRENT"] = "CURRENT";
    return SearchContainerStatus;
}({});
var $748ce020ea1d386c$export$981cf94add4585a6 = /*#__PURE__*/ function(SearchIssueStatusCategory) {
    SearchIssueStatusCategory["OPEN"] = "OPEN";
    SearchIssueStatusCategory["DONE"] = "DONE";
    return SearchIssueStatusCategory;
}({});
var $748ce020ea1d386c$export$f83401feaa563e1e = /*#__PURE__*/ function(SearchLinkedEntityGranularity) {
    SearchLinkedEntityGranularity["FULL_THREAD"] = "FULL_THREAD";
    SearchLinkedEntityGranularity["ALL_MATCHING_MESSAGES"] = "ALL_MATCHING_MESSAGES";
    SearchLinkedEntityGranularity["DEFAULT"] = "DEFAULT";
    return SearchLinkedEntityGranularity;
}({});
var $748ce020ea1d386c$export$45f36aeb819dbce5 = /*#__PURE__*/ function(SearchParticipantType) {
    SearchParticipantType["MENTIONS"] = "MENTIONS";
    SearchParticipantType["CONTRIBUTOR"] = "CONTRIBUTOR";
    SearchParticipantType["PRESENCE"] = "PRESENCE";
    return SearchParticipantType;
}({});
var $748ce020ea1d386c$export$395d337d64b9f57f = /*#__PURE__*/ function(SearchProjectType) {
    SearchProjectType["software"] = "software";
    SearchProjectType["business"] = "business";
    SearchProjectType["service_desk"] = "service_desk";
    SearchProjectType["product_discovery"] = "product_discovery";
    return SearchProjectType;
}({});
var $748ce020ea1d386c$export$95cacd63dfd98bee = /*#__PURE__*/ function(SearchResultType) {
    SearchResultType["page"] = "page";
    SearchResultType["blogpost"] = "blogpost";
    SearchResultType["database"] = "database";
    SearchResultType["whiteboard"] = "whiteboard";
    SearchResultType["embed"] = "embed";
    SearchResultType["folder"] = "folder";
    SearchResultType["space"] = "space";
    SearchResultType["attachment"] = "attachment";
    SearchResultType["comment"] = "comment";
    SearchResultType["board"] = "board";
    SearchResultType["dashboard"] = "dashboard";
    SearchResultType["filter"] = "filter";
    SearchResultType["issue"] = "issue";
    SearchResultType["plan"] = "plan";
    SearchResultType["project"] = "project";
    SearchResultType["goal"] = "goal";
    SearchResultType["project_update"] = "project_update";
    SearchResultType["goal_update"] = "goal_update";
    SearchResultType["tag"] = "tag";
    SearchResultType["focus_area"] = "focus_area";
    SearchResultType["focus_area_status_update"] = "focus_area_status_update";
    SearchResultType["ask"] = "ask";
    SearchResultType["question"] = "question";
    SearchResultType["learning"] = "learning";
    SearchResultType["document"] = "document";
    SearchResultType["repository"] = "repository";
    SearchResultType["component"] = "component";
    SearchResultType["presentation"] = "presentation";
    SearchResultType["spreadsheet"] = "spreadsheet";
    SearchResultType["message"] = "message";
    SearchResultType["object_schema"] = "object_schema";
    SearchResultType["object_type"] = "object_type";
    SearchResultType["unrecognised"] = "unrecognised";
    return SearchResultType;
}({});
var $748ce020ea1d386c$export$1eed0ec46c1a7935 = /*#__PURE__*/ function(SearchThirdPartyRangeField) {
    SearchThirdPartyRangeField["LASTMODIFIED"] = "LASTMODIFIED";
    SearchThirdPartyRangeField["CREATED"] = "CREATED";
    return SearchThirdPartyRangeField;
}({});
module.exports["SearchConfluenceDocumentStatus"] = $748ce020ea1d386c$export$75fb70288e44d634;

});

parcelRegister("882Qs", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e664998f36f6457c$export$1c108e9c11520cac = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "BwMOJ",
    name: "ContentTreeSearchEmptyLoader",
    loader: async ()=>(await (parcelRequire("aMOfG"))).ContentTreeSearchEmpty
});

const $e664998f36f6457c$export$f3cc49687d3dd9d7 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "KEbqE",
    name: "ContentTreeSearchErrorLoader",
    loader: async ()=>(await (parcelRequire("aMOfG"))).ContentTreeSearchError
});
module.exports["ContentTreeSearchEmptyLoader"] = $e664998f36f6457c$export$1c108e9c11520cac;
module.exports["ContentTreeSearchErrorLoader"] = $e664998f36f6457c$export$f3cc49687d3dd9d7;

});

parcelRegister("aMOfG", function(module, exports) {

let $7da55e0db7745518$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7da55e0db7745518$var$load("6FaFk").then(()=>parcelRequire('wyyi4'));

});

parcelRegister("4Uzty", function(module, exports) {

let $3937e923139aa9c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3937e923139aa9c6$var$load("fC3D2").then(()=>parcelRequire('a0Cao'));

});


//# sourceMappingURL=ContentTreeSearch.40229034.js.map
